export default __webpack_public_path__ + "static/media/alert_circle.ba2cc4c7.svg";